export default "__VITE_ASSET__Hsz5psDH__$_?react__"